import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import './Login.css';

const Login = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState('');

    const [password, setPassword] = useState('');


    const handleLogin = () => {

        if(
            email === 'admin@gmail.com'
            &&
            password === '1234'
        ){

      navigate('/dashboard');

        }

        else{

            navigate('/noaccess');

        }
    }


    return (

        <div className="login-page">

            <div className="login-box">

                <h1>Admin Login</h1>

                <p>
                    Login to access the dashboard.
                </p>


                <input
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />


                <input
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />


                <button onClick={handleLogin}>

                    Login

                </button>

            </div>

        </div>

    );
}

export default Login;